import { Button, Col, Row } from "reactstrap"
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import BackButton from "../../../../components/common/BackButton/BackButton"
import { useNavigate } from "react-router-dom"
import { useRef, useEffect } from "react"
import styles from './index.module.scss'
import WhiteButton from "../../../../components/SellerPortalComponents/Settings/WhiteButton/WhiteButton"

const StoreThemePreview = () => {
  const navigate = useNavigate()

  const iframeRef = useRef(null)
  useEffect(() => {
    const disableInteractions = () => {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        const iframeDoc = iframeRef.current.contentWindow.document

        if (iframeDoc && iframeDoc.body) {
          iframeDoc.body.style.pointerEvents = "none"
          iframeDoc.body.style.overflow = "hidden"
        }
      }
    }

    const iframe = iframeRef.current
    if (iframe) {
      iframe.onload = () => {
        disableInteractions()
      }
    }

    const interval = setInterval(() => {
      disableInteractions()
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <LightGrayBgWrapper>
      <BackButton />
      <div className="fw-semibold fs-5">Store Theme Preview</div>
      <div className="d-flex align-items-end flex-column gap-2">
        <div>
          <Button color="info" onClick={() => navigate("/settings/create-new-theme")}>
            Use this Theme
          </Button>
        </div>
        <div>Cancel</div>
      </div>

      <Row className="g-0 position-relative">
        <Col>
          <iframe
            ref={iframeRef}
            id="themePreview"
            title="Theme Preview"
            src="http://localhost:3000/brand-store"
            style={{
              width: "100%",
              height: "2086px",
              border: "none",
            }}
          />
        </Col>
        <Col>
            <div>
              <div className={styles['header-connecting-line']} />
              <div className={`${styles['header-label']} bg-white p-1 border border-secondary rounded`}>Header</div>
              <div className={styles['promotions-connecting-line']} />
              <div className={`${styles['promotions-label']} bg-white p-1 border border-secondary rounded`}>Promotions</div>
              <div className={styles['promotion-connecting-line']} />
              <div className={`${styles['promotion-label']} bg-white p-1 border border-secondary rounded`}>Promotion</div>
              <div className={styles['product-connecting-line']} />
              <div className={`${styles['product-label']} bg-white p-1 border border-secondary rounded`}>Product</div>
              <div className={styles['hot-deals-promotion-connecting-line']} />
              <div className={`${styles['hot-deals-promotion-connecting-label']} bg-white p-1 border border-secondary rounded`}>Promotion</div>
            </div>
        </Col>
      </Row>
    </LightGrayBgWrapper>
  )
}

export default StoreThemePreview
